import { z } from 'zod';

export const DataAccessRequestFormSchema = z.object({
  requestType: z.enum([
    'REQUEST_DATA',
    'REQUEST_DATA_DELETION',
    'REQUEST_DATA_CORRECTION',
    'OTHER',
  ]),
  phoneNumber: z.string(),
  email: z.string().email('Invalid email'),
  comments: z.string().max(1024, 'Max 1024 characters').optional(),
});

export type DataAccessRequestFormSchemaType = z.infer<
  typeof DataAccessRequestFormSchema
>;
